<!-- <div [innerHTML]="svg | pipeSafeHTML" class="mwp-svg">
</div> -->
<div class="mwp-svg" [class]="SvgColor">
    @if (ToolTipMessage) {
        <mat-icon [svgIcon]="SvgMatType" [class]="SvgColor" [matTooltip]="ToolTipMessage" matTooltipPosition="right" [matTooltipClass]='ToolTipClass'/>
    } @else {
        <mat-icon [svgIcon]="SvgMatType" [class]="SvgColor"/>
    }
</div>